import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import * as moment from 'moment';

@Component({
  selector: 'app-individual-new-activity',
  templateUrl: './individual-new-activity.component.html',
  styleUrls: ['./individual-new-activity.component.scss']
})
export class IndividualNewActivityComponent implements OnInit {

	@Input() data: any;
	@Input() coaching_plan: any;
	@Input() activity_user_data: any;
	@Input() selected_activity_type_id: any;

	@Output() newactivityDetailsClosed = new EventEmitter<any>();

 	user_details: any;
	user_role: any = "";

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private datePipe: DatePipe,
		private domSanitizer: DomSanitizer,
		private dialog: MatDialog,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 3) {
			this.user_role = "Executive";
		} else if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
		} else if (this.user_details.role.role == 10) {
			this.user_role = "Leadership";
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
		} else if (this.user_details.role.role == 12) {
			this.user_role = "Wholesaler";
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
		}

		this.getActivityEmptyData();
		this.getCommunicationTypes();

		setTimeout(() => {
			this.openNewActivityModal();
		}, 200);
  }

  activity_data_loaded: boolean = false;
  activity_data: any;
  getActivityEmptyData() {
		this.activity_data_loaded = false;
		let route: any = "/emptyactivity/";
		route = route + "?parent_task=true"
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.activity_data = res;
				this.activity_data.scheduled_date = new Date(this.activity_data.scheduled_date);
				this.activity_data_loaded = true;


			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	communication_type_list: any = [];
	getCommunicationTypes() {
		this.commonService.getData('/communicationType/?no_page=true').subscribe(
			(res: any) => {
				this.communication_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	@ViewChild('newActivityModal') newActivityModal: TemplateRef<any>;
	private newActivityModalRef: MatDialogRef<TemplateRef<any>>;

	openNewActivityModal() {
		this.newActivityModalRef = this.dialog.open(this.newActivityModal, { disableClose: true });
		this.newActivityModalRef.afterClosed().subscribe((result) => {
			this.closeNewActivityModal();
		});
	}

	closeNewActivityModal() {
		this.newActivityModalRef.close();
		this.newactivityDetailsClosed.emit({ type: "Closed"});
	}

	new_activity_data_errors: any = {
		communication_type: false,
		name: false,
		scheduled_date: false,
	};

	new_activiity_data_loader: boolean = false;
	saveNewActivityData() {
		if (this.activity_data.communication_type != "" && this.activity_data.communication_type != null) {
			this.new_activity_data_errors.communication_type = false;
		} else {
			this.new_activity_data_errors.communication_type = true;
		}

		if (this.activity_data.name != "" && this.activity_data.name != null) {
			this.new_activity_data_errors.name = false;
		} else {
			this.new_activity_data_errors.name = true;
		}

		if (this.activity_data.scheduled_date != "" && this.activity_data.scheduled_date != null) {
			this.new_activity_data_errors.scheduled_date = false;
		} else {
			this.new_activity_data_errors.scheduled_date = true;
		}

		if (
			this.new_activity_data_errors.communication_type == false &&
			this.new_activity_data_errors.name == false &&
			this.new_activity_data_errors.scheduled_date == false
		) {

			let payload: any = JSON.parse(JSON.stringify(this.activity_data));

			if (this.user_role != 'Advisor Manager' && this.user_role != 'Executive' && this.user_role != 'Leadership' && this.user_role != 'Marketing Team') {
				payload.afa_id = this.activity_data.afa_id;
			}

			if (this.activity_data.actual_date != "" && this.activity_data.actual_date != null) {
				payload.actual_date = moment(this.activity_data.actual_date).format();
			}

			if (this.data.activity_type == 1) {
				payload.activity_type = 2;
			} else if (this.data.activity_type == 5) {
				payload.activity_type = 3;
			} else {
				payload.activity_type = this.data.activity_type;
			}

			if (this.data.parent_activity != null) {
				payload.parent_activity = this.data.parent_activity;
				payload.source = this.data.source;
			}

			let route: any = "";

			if (this.data.parent_activity != null) {
				route = "/addsubtask/";
				if (this.user_role != 'Advisor Manager') {
					payload.advisor = this.user_details.id;
					if (this.data.user_type == "Client") {
						payload.client = this.data.client;
					} else if (this.data.user_type == "Prospect") {
						payload.prospect = this.data.prospect_id;
					}
				} else {
					if (this.user_role != 'Executive' || this.user_role != 'Marketing Team') {
						payload.created_by = this.user_details.id;
						payload.created_to = this.data.created_to;
					} else if (this.user_role == 'Wholesaler') {
						payload.wholesaler = this.user_details.id;
						payload.advisor = this.data.advisor;
					} else if (this.user_role == 'Leadership') {
						payload.recruiter = this.user_details.id;
						payload.advisor = this.data.advisor;
					} else {
						payload.advisor_manager = this.user_details.id;
						payload.advisor = this.data.advisor;

						if (this.coaching_plan) {
							payload.coaching_plan = this.coaching_plan.id;
						}
					}

				}
				// if (this.data.source == 'csa') {
				// 	// route = "/clientsalesactivity/";
				// 	payload.client = this.data.client;
				// 	payload.advisor = this.user_details.id;
				// } else if (this.data.source == 'lpa') {
				// 	// route = "/leadprospectactivity/";
				// 	payload.prospect = this.data.prospect;
				// 	payload.advisor = this.user_details.id;
				// } else if (this.data.source == 'ama') {

				// }
			} else {
				if (this.user_role == "Executive") {
					route = '/internalactivity/';

					// payload.created_to = this.activity_user_data.id;
					// payload.created_by = this.user_details.id;

					payload.created_to = this.selected_activity_type_id;
					payload.created_by = this.user_details.id;

				} else if (this.user_role == "Leadership") {
					// route = '/internalactivity/';
					route = '/recruiteractivity/';
					payload.recruiter = this.user_details.id;
					payload.advisor = this.activity_user_data.id;

					// payload.created_to = this.activity_user_data.id;
					// payload.created_by = this.user_details.id;

					// payload.created_to = this.selected_activity_type_id;
					// payload.created_by = this.user_details.id;

				} else if (this.user_role == "Marketing Team") {
					// route = '/internalactivity/';
					route = '/clientsalesactivity/';
					payload.created_to = this.activity_user_data.id;
					payload.created_by = this.user_details.id;

					payload.client = this.activity_user_data.id;
					payload.advisor = this.user_details.id;
				} else if (this.user_role == "Wholesaler") {
					route = '/wholesaleractivity/';
					payload.wholesaler = this.user_details.id;
					payload.advisor = this.activity_user_data.id;
				} else if (this.user_role != 'Advisor Manager') {
					if ('is_client' in this.activity_user_data) {
						route = "/leadprospectactivity/";
						payload.prospect = this.activity_user_data.id;
						payload.advisor = this.user_details.id;
					} else {
						route = "/clientsalesactivity/";
						payload.client = this.activity_user_data.id;
						payload.advisor = this.user_details.id;
					}
				} else {
					if (this.activity_user_data.is_client == true) {
						route = "/clientsalesactivity/";
						payload.client = this.activity_user_data.id;
						payload.advisor = this.user_details.id;
					} else if (this.activity_user_data.is_client == false) {
						route = "/leadprospectactivity/";
						payload.prospect = this.activity_user_data.id;
						payload.advisor = this.user_details.id;
					} else {
						route = "/advisormanageractivity/";
						payload.advisor = this.activity_user_data.id;
						payload.advisor_manager = this.user_details.id;

						if (this.coaching_plan) {
							payload.coaching_plan = this.coaching_plan.id;
						}
					}

				}
			}

			this.new_activiity_data_loader = true;
			this.commonService.postData(route, payload).subscribe(
					(res: any) => {
						this.activity_data = res;
						this.commonService.showToast('success', "Activity Added Successfully.");
						this.new_activiity_data_loader = false;
						this.closeNewActivityModal();
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						this.new_activiity_data_loader = false
					},
				);

		}
	}

}
